/* eslint no-inline-comments: 0 */

// The Org rules tab of Classification rules (../classification_rules/), the
// counterpart of ../network_rules/_routes.js. Mounted under
// `classification-rules/`.

const Overview = () => import( /* webpackChunkName: "group-network-rules" */ `./org-overview.vue` );
const RuleUpsert = () => import( /* webpackChunkName: "group-network-rules" */ `./org-rule-upsert.vue` );

export const org_children = [
	{
		path: `org`,
		name: `classification-rules-org`,
		component: Overview,
		meta: {
			title: `Classification rules: Org rules`
		}
	},
	{
		path: `org/rules/new`,
		name: `classification-rules-org-rule-add`,
		component: RuleUpsert,
		meta: {
			title: `Add Org Rule`
		}
	},
	{
		path: `org/rules/:uuid`,
		name: `classification-rules-org-rule-edit`,
		component: RuleUpsert,
		meta: {
			title: `Edit Org Rule`
		}
	}
];
